import React from 'react';
import {Link} from "../Link";

export const Breadcrumb = ({ items, onNavigate }) => {
  // 篩掉沒名字或是 root ('/')
  const trail = items.filter((item) => item.name && item.name !== '/');

  // 手動在最前面加上「全部」
  const fullTrail = [{ id: '', name: '全部' }, ...trail];

  return (
    <div className="flex items-center text-base text-gray-700 overflow-x-auto whitespace-nowrap scrollbar-hide px-1">
      {fullTrail.map((item, index) => (
        <div key={item.id || 'root'}>
          {index > 0 && (
            <span className="mx-2 text-gray-400">
              /
            </span>
          )}
          <Link
            onClick={() => onNavigate(item.id)}
            disabled={index === fullTrail.length - 1}
            label={item.name}
          />
        </div>
      ))}
    </div>
  );
};